import axios from '@/utils/axios';

// 获取兑换商品列表
export function GetExchangeGoodsList(params) {
    return axios({
        url: '/stampShop/exchangePrize/list',
        method: 'get',
        params,
    });
}

// 兑换搜索
export function ExchangeSearch(params) {
    return axios({
        url: '/stampShop/exchangeSearch',
        method: 'get',
        params,
    });
}

// 兑换商品类型
export function ExchangeGoodsType(params) {
    return axios({
        url: '/stampShop/exchangeGoodsType',
        method: 'get',
        params,
    });
}

// 获取兑换商品详情
export function GetExchangeGoods(params) {
    return axios({
        url: '/stampShop/exchangePrize',
        method: 'get',
        params,
    });
}

// 发送验证码
export function VerifyCode(params) {
    return axios({
        url: '/stampShop/captcha/send',
        method: 'post',
        params,
    });
}

// 印花兑换
export function stampExchange(data) {
    return axios({
        url: '/stampShop/stamp/exchange',
        method: 'post',
        data,
    });
}

// 优惠券列表
export function voucherList(params) {
    return axios({
        url: '/stampShop/voucher/list',
        method: 'get',
        params,
    });
}

// 获取优惠券详情
export function getVoucher(params) {
    return axios({
        url: '/stampShop/voucher',
        method: 'get',
        params,
    });
}

// 取消优惠券
export function voucherCancel(data) {
    return axios({
        url: '/stampShop/voucher/cancel',
        method: 'post',
        data,
    });
}

// 兑换记录列表
export function exchangeLogList(params) {
    return axios({
        url: '/stampShop/exchangeLog/list',
        method: 'get',
        params,
    });
}

// 获取兑换记录详情
export function getExchangeLog(params) {
    return axios({
        url: '/stampShop/exchangeLog',
        method: 'get',
        params,
    });
}

// 优惠券订单列表
export function voucherOrderList(params) {
    return axios({
        url: '/stampShop/voucher/order/list',
        method: 'get',
        params,
    });
}

// 印花抽奖活动列表
export function lotteryStampShopActivityList(params) {
    return axios({
        url: '/stampShop/lotteryStampShopActivityList',
        method: 'get',
        params,
    });
}

// 获取活动信息
export function getStampShopActivity(params) {
    return axios({
        url: '/stampShop/stampShopActivity',
        method: 'get',
        params,
    });
}

// 奖品轮盘列表
export function awardWheelList(params) {
    return axios({
        url: '/stampShop/awardWheelList',
        method: 'get',
        params,
    });
}

// 印花抽奖
export function stampLottery(data) {
    return axios({
        url: '/stampShop/stampLottery',
        method: 'post',
        data,
    });
}

// 礼品轮盘列表
export function giftWheelList(params) {
    return axios({
        url: '/stampShop/giftWheelList',
        method: 'get',
        params,
    });
}

// 礼品抽奖
export function giftLottery(data) {
    return axios({
        url: '/stampShop/giftLottery',
        method: 'post',
        data,
    });
}

// 抽奖券数量
export function lotteryTicketNumber(params) {
    return axios({
        url: '/stampShop/lotteryTicketNumber',
        method: 'get',
        params,
    });
}
